import elementEnLocale from 'element-ui/lib/locale/lang/en';
import elementNlLocale from 'element-ui/lib/locale/lang/nl';
import elementFrLocale from 'element-ui/lib/locale/lang/fr';

import enLocale from './en.json';
import nlLocale from './nl.json';
import frLocale from './fr.json';

const messages = {
	en: {
		...enLocale,
		...elementEnLocale
	},
	nl: {
		...nlLocale,
		...elementNlLocale
	},
	fr: {
		...frLocale,
		...elementFrLocale
	}
};

export default messages;
